
export const BUILD_INFO = {
  version: "0.14.0",
  buildDate: "2026-11-04T17:20:45.498Z",
  gitCommit: "08c8be2",
  gitCommitFull: "08c8be25be3f2a323e74f3304d84c6f37a680fe3",
  gitBranch: "feat/DEL-1009-admin-offer-referencing",
  gitCommitMessage: "chore: merge savings and offer referencing into admin offer referencing (DEL-1009)",
  gitAuthor: "Hadi Nazifi",
  gitCommitDate: "2026-11-04T15:31:24Z",
  nodeVersion: "v22.14.0"
} as const;
